import lang from '@/lang/middleware/about';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const subtitle = store.$i18n.t('index.jumbotron.subtitle');
  const title = store.$i18n.t('index.title');
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
